import { AppNotification } from '../types';
import apiClient from './api';

export const notificationService = {
  async getNotifications() {
    return apiClient.get<AppNotification[]>('/notifications', { useCache: true });
  },

  async markAsRead(notificationId: string) {
    return apiClient.put<AppNotification>(
      `/notifications/${notificationId}/read`,
      {},
      {
        invalidateCache: ['/notifications'],
      },
    );
  },

  async markAllAsRead() {
    return apiClient.put<boolean>(
      '/notifications/read-all',
      {},
      {
        invalidateCache: ['/notifications'],
      },
    );
  },

  async deleteNotification(notificationId: string) {
    return apiClient.delete<boolean>(`/notifications/${notificationId}`, {
      invalidateCache: ['/notifications'],
    });
  },

  async updateNotificationPreferences(preferences: { email: boolean; push: boolean; inApp: boolean }) {
    return apiClient.put<boolean>('/notifications/preferences', preferences, {
      invalidateCache: ['/notifications/preferences'],
    });
  },

  async getUnreadCount() {
    return apiClient.get<number>('/notifications/unread-count', { useCache: true });
  },
};
